import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import {Alert, Button, Card, Popconfirm, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiLogOut, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsJustify, BsPencil} from "react-icons/bs";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import Inscripcio from "../../model/inscripcions/Inscripcio";
import LoginInscripcions from "./LoginInscripcions";
import InscripcioLlista from "./components/InscripcioLlista";
import {GetInscripcions} from "../../dao/inscripcions/GetInscripcions";
import {format} from "date-fns";
import {GetInscripcionsNova} from "../../dao/inscripcions/GetInscripcionsNova";
import NavBarInscripcions from "../components/NavBarInscripcions";
import {QuestionCircleOutlined} from "@ant-design/icons";

const InscripcioGestio = () => {
    const titol: string = "INSCRIPCIONS";
    const nomPermis: string = "INSCRIPCIONS";

    const {
        isLoggedIn,
        userId,
        user,
        page,
        userDni,
        userCognom,
        setLoggedIn,
        setUserDni,
        setUserCognom
    } = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Inscripcio[]>([]);
    const [elementSelected, setElementSelected] = useState<Inscripcio>(new Inscripcio());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    useEffect(() => {
        if (userDni !== '' && userCognom !== '') {
            handleLoadingChange(true)
            checkDades();
        }
    }, [userDni, userCognom]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetInscripcions(userCognom, userDni, page);
        setDades(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    async function afegirElement() {
        handleLoadingChange(true)
        const dades = await GetInscripcionsNova(userDni, userCognom, page);
        //console.log(JSON.stringify(dades));
        //console.log(">>>>"+dades[0]);
        //console.log(">>>>"+dades[0].id);
        navigate(`/inscripcions/gestio/${dades[0].id}`);
        //checkDades();
    }

    function togleNouElement(element: Inscripcio) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal() {
        setNouElement(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Inscripcio[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.cognom,
            value: element.cognom,
        }));
        setNomFiltres(ingredientNames);
    }

    function editarInscripcio(id: number) {
        navigate(`/inscripcions/gestio/${id}`);
    }

    function penjarDocumentacio(id: number) {
        navigate(`/inscripcions/gestio/${id}/documentacio`);
    }

    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<Inscripcio> = [
        {
            key: 'id',
            title: '',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            render: (estat, ele) => (
                permisosEdicio && (
                    ele.id
                )
            )
        },
        {
            key: 'alta',
            title: 'Data d\'alta',
            dataIndex: 'alta',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{format(new Date(ele.alta.toString()), 'dd/MM/yyyy')}</Tag>
            )
        },
        {
            key: 'activitat',
            title: 'Activitat',
            dataIndex: 'activitat',
            width: 30,
            render: (estat, ele) => (
                <p>{ele.activitat === '' ? <Tag color={"success"}>NOVA INSCRIPCIÓ</Tag> : ele.activitat}</p>
            )
        },
        {
            key: 'actiu',
            title: 'Estat de l\'inscripció',
            dataIndex: 'actiu',
            width: 30,
            render: (estat, ele) => (
                <Tag color={(ele.actiu === 0 && (ele.estat === 'actiu' || ele.estat === null)) ? Colors.colors.color5 :
                    ((ele.actiu === 0 && ele.estat !== 'actiu') ? Colors.colors.color4 :
                            (ele.actiu === 1 ? Colors.colors.color3 :
                                    (ele.actiu === 2 ? Colors.colors.color2 : Colors.colors.color1)
                            )
                    )}>
                    {(ele.actiu === 0 && (ele.estat === 'actiu' || ele.estat === null)) ? "NO FINALITZADA" :
                        ((ele.actiu === 0 && ele.estat !== 'actiu') ? "NO EDITABLE" :
                                (ele.actiu === 1 ? "FINALITZADA" :
                                        (ele.actiu === 2 ? "FACTURADA" : "ERROR")
                                )
                        )
                    }</Tag>
            )
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {/* {(permisosEdicio) && ( */}
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                            {" "}
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}
                                    onClick={() => deleteElement(ele.id)}><BiTrash/></Button>
                            {" "}
                        </>
                    {/* )} */}
                    {/* {(ele.actiu === 1 || ele.actiu === 2) && ele.estat === 'actiu' && */}
                        <Button title={"Penjar Documents"}  onClick={() => penjarDocumentacio(ele.id)}
                                style={{backgroundColor: Colors.colors.color3}}>DOCUMENTACIÓ</Button>
                    {/* } */}
                    {/* {ele.actiu === 0 && (ele.estat === 'actiu' || ele.estat === null) && */}
                        <Button title={"Modificar inscripció"}
                                onClick={() => editarInscripcio(ele.id)}
                                style={{backgroundColor: Colors.colors.color5}}>MODIFICAR</Button>
                    {/* } */}
                </>
            ),
        },
    ];

    const tableProps: TableProps<Inscripcio> = {
        loading
    };

    const onChange: TableProps<Inscripcio>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            //console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender = (ele: Inscripcio) => {
        return (
            <InscripcioLlista element={ele}/>
        );
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    function logout() {
        setUserDni('');
        setUserCognom('');
        setLoggedIn(false);
        navigate("/inscripcions");
    }

    if (isLoggedIn) {
        return (
            <div>
                <NavBarInscripcions/>
                <div className={"general"}>
                    <h4 className={"titol"}>{titol}: {userCognom} ({userDni})</h4>
                    
                    <Card bordered={true} className={"elemento"}>
                        <div style={{marginBottom:10}}>
                            <Button title={"Sortssir"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                                logout()}><BiLogOut/> SORTIR</Button>{" "}
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color6}} onClick={() =>
                                checkDades()}><BiRefresh/> REFRESCAR</Button>{" "}

                            <Popconfirm
                                title="NOVA INSCRIPCIÓ"
                                description={(<>{"Vols crear una nova inscripció? Prem el botó OK."}<br/>
                                    {"En cas de voler pujar documents fes-ho al botó de DOCUMENTACIÓ."} <br/>
                                    {"En cas de voler modificar una existent no finalitzada al botó MODIFICAR."}
                                </>)}
                                onConfirm={() =>
                                    afegirElement()}
                                icon={<QuestionCircleOutlined style={{color: Colors.colors.color5}}/>}
                            >
                                <Button title={"Crear nova inscripció"} style={{backgroundColor: Colors.colors.color5}} >
                                    <BiPlus/>NOVA INSCRIPCIÓ</Button>
                            </Popconfirm>
                        </div>
                        
                        <Alert message={(<>{"Utilitza el botó "}
                            <Button title={"Crear nova inscripció"} style={{backgroundColor: Colors.colors.color5}}><BiPlus/>NOVA INSCRIPCIÓ</Button>
                            {" per crear una nova inscripció. Amb el botó "}
                            <Button title={"Modificar inscripció"}
                                    style={{backgroundColor: Colors.colors.color3}}>DOCUMENTACIÓ</Button>
                            {" pots pujar documents a inscripcions Finalitzades."}</>)} type={"info"} />
                        
                        <br/>
                        {visible && (
                            <div style={{overflowX: 'auto'}}>
                                <Table
                                    {...tableProps}
                                    onChange={onChange}
                                    columns={columns}
                                    /*expandable={{
                                        expandedRowRender: (record) =>
                                            expandedRowRender(record),
                                        rowExpandable: (record) => true,

                                    }}*/
                                    dataSource={coleccio}
                                    size={window.innerWidth < 768 ? "small" : "middle"}
                                />
                            </div>
                        )}
                    </Card>
                   
                </div>
            </div>
        );
    } else {
        return (
            <LoginInscripcions/>
        );
    }
};
export default InscripcioGestio;
